module.exports = __webpack_public_path__ + "media/application/images/perish/title-1500-00db1b0d843e2ae44cac4df06304a748.png";